import Indicator, { IndicatorType } from '../types/Indicator'

const MovingAverageConvergenceDivergence: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'movingAverageConvergenceDivergence',
  label: 'Moving Average Convergence Divergence',
  nickname: 'MACD',
  fields: ['macd', 'signal'],
  params: {
    fastPeriod: 5,
    slowPeriod: 10,
    signalPeriod: 9,
  },
}

export default MovingAverageConvergenceDivergence
